var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDoodle1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 75,
    viewBox: "0 0 64 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7651 56.674C56.9303 55.675 57.9599 54.784 58.9625 53.92C59.8296 55 61.2115 55.945 61.4554 57.16C62.4851 61.9121 63.1896 66.7182 63.9212 71.4973C64.3277 74.2513 63.1625 75.3584 60.3986 74.8994C56.9845 74.3323 53.5161 73.8733 50.2103 72.9553C49.1535 72.6583 48.4761 71.0383 47.609 70.0123C48.8012 69.4183 49.9664 68.4192 51.2128 68.3382C52.7574 68.2302 54.3561 68.8512 56.6322 69.2832C45.1432 40.0417 25.8232 18.0093 -5.31099e-08 1.21501C0.216774 0.810004 0.433548 0.405005 0.677422 -2.76792e-06C1.89677 0.378004 3.22451 0.566994 4.28129 1.188C16.0142 8.12713 26.3109 16.8213 35.3883 26.9465C43.5716 36.0726 50.427 46.1168 55.7922 56.674L55.7651 56.674Z",
    fill: "#714B67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoodle1);
export default __webpack_public_path__ + "static/media/arrow_doodle_1.a6210b7fbdacac13db63b7270a844073.svg";
export { ForwardRef as ReactComponent };